// IP Geolocation API Response Type
interface GeoLocationResponse {
  status: string;
  country: string;
  countryCode: string;
  region: string;
  regionName: string;
  city: string;
  zip: string;
  lat: number;
  lon: number;
  timezone: string;
  isp: string;
  org: string;
  as: string;
  query: string;
}

// Function to get geolocation from IP
const getGeolocation = async (): Promise<GeoLocationResponse | null> => {
  try {
    //https://ip-api.com/json/
    const response = await fetch('http://ip-api.com/json/', {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data: GeoLocationResponse = await response.json();

    if (data.status === 'success') {
      return data;
    } else {
      console.warn('⚠️ Geolocation API returned fail status');
      return null;
    }
  } catch (error) {
    console.error('❌ Error fetching geolocation:', error);
    return null;
  }
};

export default getGeolocation;
